import React from 'react';

// COMPONENTS
import PropTypes from 'prop-types';
import List from '../../../Framework/Pages/List/List';
import Text from '../../../Framework/Components/Text';
import Edit from '../../../Framework/Components/Buttons/Edit';
import Delete from '../../../Framework/Components/Buttons/Delete';
import CategorySearch from '../CategorySearch';

const ArticleCategorySearch = (props) => (
    <CategorySearch {...props} categoryType="article" />
);

const ArticleCategoryList = (props) => {
    return (
        <List search={ArticleCategorySearch} {...props}>
            <Text name="id" />
            <Edit name="name" resource="categories" />
            <Text name="slug" />
            <Delete name="delete" list />
        </List>
    );
};

ArticleCategorySearch.propTypes = {
    onChange: PropTypes.func.isRequired,
    entity: PropTypes.object.isRequired,
};

export default ArticleCategoryList;
